import React, { useContext } from 'react';

import { PairWalletsContext } from 'context/PairWalletsContext/PairWalletsContext';
import { IDexPair } from 'types/pairs';

interface Props {
  dexPair: IDexPair;
}

const TokenFeeHead: React.FC<Props> = React.memo(({ dexPair }) => {
  const { totalBalances } = useContext(PairWalletsContext);

  return (
    <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column' }}>
      <span>{dexPair.token_fee.symbol}</span>
      <span>({totalBalances.fee})</span>
    </div>
  );
});

export default TokenFeeHead;
